import { supabase } from '../../../../lib/supabase'

export default function FixturesTable({ fixtures, onEdit, onRefresh }) {
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this fixture?')) return
    await supabase.from('fixtures').delete().eq('id', id)
    onRefresh()
  }

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-black/20">
            {['Home', 'Score', 'Away', 'Date', 'Venue', 'Status', ''].map((h) => (
              <th key={h} className="text-left py-3 px-4 text-xs text-gray-500 uppercase tracking-widest font-semibold whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {fixtures.map((fixture) => (
            <tr key={fixture.id} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
              <td className="py-3 px-4 font-semibold whitespace-nowrap text-gray-900 dark:text-white">{fixture.home_team}</td>
              <td className="py-3 px-4 font-black text-gray-900 dark:text-white whitespace-nowrap">
                {fixture.status === 'completed' ? `${fixture.home_score} - ${fixture.away_score}` : '-'}
              </td>
              <td className="py-3 px-4 font-semibold whitespace-nowrap text-gray-900 dark:text-white">{fixture.away_team}</td>
              <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">
                {new Date(fixture.match_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
              </td>
              <td className="py-3 px-4 text-gray-500 text-xs">{fixture.venue}</td>
              <td className="py-3 px-4">
                <span className={`text-xs font-bold uppercase tracking-widest px-2 py-1 ${
                  fixture.status === 'scheduled'
                    ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'
                    : 'bg-gray-200 dark:bg-white/10 text-gray-400'
                }`}>
                  {fixture.status}
                </span>
              </td>
              <td className="py-3 px-4">
                <div className="flex gap-3">
                  <button onClick={() => onEdit(fixture)} className="text-xs text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-bold uppercase tracking-widest transition-colors">Edit</button>
                  <button onClick={() => handleDelete(fixture.id)} className="text-xs text-red-500 hover:text-red-400 font-bold uppercase tracking-widest transition-colors">Delete</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}